<template>
  <div class="packages-control">
    <div class="row">
      <div class="small-4 columns padding-R">
        <a :class="{'button cta block small error':true, 'disabled':disableBreakPkg}" href="javascript:;" @click="breakPackage">BREAK PACKAGE</a>
      </div>
      <div class="small-4 columns padding-L padding-R">
        <a class="button cta block small warning" href="javascript:;" @click="removeFromPool">REMOVE FROM POOL</a>
      </div>
      <div class="small-4 columns padding-L">
        <a class="button cta block small" href="javascript:;" @click="moveToPool">MOVE TO POOL</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'packages-control',
  data () {
    return {
      disableBreakPkg: false
    }
  },
  props: [ 'forDispatch' ],
  computed: {
    checkPkgs () {
      if (this.forDispatch) {
        return this.$store.state.routing.packages.checkedForDispatch
      }
      return this.$store.state.routing.packages.checked
    }
  },
  methods: {
    isValid (title, message) {
      let self = this
      let checkedPackages = self.$store.state.routing.packages.checked
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch
      }
      if (checkedPackages.length <= 0 || checkedPackages.length > 1) {
        self.$store.commit('routing/showRoutingModal')
        self.$store.commit('routing/setRoutingValidationModal', {
          show: true,
          title: title,
          message: message
        })
        return false
      }
      return true
    },
    moveToPool () {
      let self = this
      if (!self.isValid('You missed something', 'Please select only 1 package to move to the pool.')) {
        return
      }
      let checkedPackages = self.$store.state.routing.packages.checked
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch
      }
      self.$store.commit('routing/showRoutingModal')
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Moving package ' + checkedPackages[0] + ' to pool...'
      })
      self.$sdk.post('/admin/package/' + checkedPackages[0] + '/pool', {
        token: self.$store.state.session.sessionToken
      }, r => {
        let success = true
        let message = 'Successfully moved package ' + checkedPackages[0] + ' to the pool.'
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        }
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        setTimeout(() => {
          self.$store.commit('routing/hideRoutingModal')
        }, 1000)
      })
    },
    removeFromPool () {
      let self = this
      if (!self.isValid('You missed something', 'Please select only 1 package to remove from the pool.')) {
        return
      }
      let checkedPackages = self.$store.state.routing.packages.checked
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch
      }
      self.$store.commit('routing/showRoutingModal')
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Removing package ' + checkedPackages[0] + ' from pool...'
      })
      self.$sdk.delete('/admin/package/' + checkedPackages[0] + '/pool', {
        token: self.$store.state.session.sessionToken
      }, r => {
        let success = true
        let message = 'Successfully removed package ' + checkedPackages[0] + ' from the pool.'
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        }
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        setTimeout(() => {
          self.$store.commit('routing/hideRoutingModal')
        }, 1000)
      })
    },
    breakPackage () {
      let self = this
      if (!self.isValid('You missed something', 'Please select only 1 package to break.')) {
        return
      }

      let checkedPackages = self.$store.state.routing.packages.checked
      if (self.forDispatch) {
        checkedPackages = self.$store.state.routing.packages.checkedForDispatch
      }
      self.$store.commit('routing/showRoutingModal')
      self.$store.commit('routing/setRoutingAjaxModal', {
        show: true,
        loading: true,
        success: false,
        message: 'Breaking package ' + checkedPackages[0] + '...'
      })
      self.$sdk.delete('/admin/package/' + checkedPackages[0], {
        token: self.$store.state.session.sessionToken
      }, r => {
        let success = true
        let message = 'Successfully broken package ' + checkedPackages[0] + '.'
        if (r.error) {
          console.log(r)
          success = false
          message = 'Oops. Something went wrong. Please try again later.'
        }
        self.$store.commit('routing/setRoutingAjaxModal', {
          show: true,
          loading: false,
          success: success,
          message: message
        })

        if (success) {
          self.$store.commit('routing/removePackageItem', checkedPackages[0])
          self.$store.commit('routing/clearCheckedPackages')
          if (self.forDispatch) {
            self.$store.commit('routing/clearCheckedPackagesForDispatch')
          }
        }

        setTimeout(() => {
          self.$store.commit('routing/hideRoutingModal')
        }, 1000)
      })
    }
  },
  watch: {
    checkPkgs (value) {
      let pkgs = this.$store.state.routing.packages.items
      this.disableBreakPkg = false
      for (let index in value) {
        let pkgIndex = pkgs.findIndex(x => x.id === value[index])
        if (pkgs[pkgIndex].driver && pkgs[pkgIndex].driver.ID) {
          this.disableBreakPkg = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }

@media only screen and (max-width: 430px) {
  .padding-R { padding-right: 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/PackagesControl.vue